<script setup>
    import {onMounted, ref} from "vue";
    import {ModalsContainer, useModal} from 'vue-final-modal'
    import {getCookie, setCookie} from "@util/cookies";
    import {sendToPage} from "@util/api";

    import Modal from "@component/Modal/Modal.vue";

    const {
        confirmButton,
        content,
        denyButton,
        title,
    } = HCP_POPUP;
    const {siteUrl} = GLOBAL;

    const cookieName = 'hcp-popup';
    const hcpCookie = getCookie(cookieName);

    /**
     * Modal Setup
     */
    const {open, close} = useModal({
        component: Modal,
        attrs: {
            content: content,
            confirmText: confirmButton,
            denyText: denyButton,
            title,
            modalId: 'hcp-modal',
            onConfirm() {
                setCookie(cookieName, {popupDismissed: true,})
                close()
            },
            onDeny() {
                // Set the cookie incase somehow
                // the user dismisses the popup
                setCookie(cookieName, {popupDismissed: false,})
                sendToPage(siteUrl)
                close()
            }
        },
    })

    onMounted(() => !hcpCookie?.popupDismissed && open())

</script>

<template>
    <ModalsContainer />
</template>

<script>
    export default {
        name: "HCP Modal"
    }
</script>

<style lang="scss" scoped>

</style>
